import React from 'react'
import Explorer from '../../components/Explorer'

/**
 * Rail izquierdo de series (cromo Studio).
 * Reutiliza Explorer + mismos handlers; la presentación vive en skins/studio.css.
 */
function StudioSeriesRail({
  explorer,
  onSelectSeries,
  color,
  autoSelectFirstSeries,
  onAutoShowExplorer,
  ...explorerExtras
}) {
  return (
    <div className="udv-studio-series-rail">
      <div className="udv-studio-series-label">Series browser</div>
      <div className="udv-studio-series-body">
        <Explorer
          explorer={explorer}
          onSelectSeries={onSelectSeries}
          color={color}
          isMobile={false}
          embedded
          autoSelectFirstSeries={autoSelectFirstSeries}
          onAutoShowExplorer={onAutoShowExplorer}
          {...explorerExtras}
        />
      </div>
    </div>
  )
}

export default StudioSeriesRail
